module.exports = __webpack_public_path__ + "static/media/fvs_valve1_13.2db2c707.jpg";